import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { ChatMessageDocument } from '@models';
import {
  ChatDocumentViewer,
  ProviderPatientDocumentsService,
  Utils,
} from '@services';
import { PdfPreviewDialogComponent } from '@ui-lib';
import { Observable, take } from 'rxjs';

@Injectable()
export class ProviderChatDocumentViewer extends ChatDocumentViewer {
  private readonly dialog = inject(Dialog);
  private readonly documents = inject(ProviderPatientDocumentsService);

  view(document: ChatMessageDocument): void {
    this.dialog.open(PdfPreviewDialogComponent, {
      data: { name: document.name, blob$: this.fileBlob(document) },
    });
  }

  download(document: ChatMessageDocument): void {
    this.fileBlob(document)
      .pipe(take(1))
      .subscribe(blob => Utils.downloadBlob(blob, document.name));
  }

  private fileBlob(document: ChatMessageDocument): Observable<Blob> {
    return this.documents.viewFile(document.id);
  }
}
